import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Formik, Form } from "formik";
import RequestMultiFactorTokenFormik from "app/components/RequestMultiFactorTokenFormik";
import { nameof } from "core/util/nameof";
import Input from "app/components/Input";
import { useIndueCardDetailsQuery, useIndueCardChangePinMutation, } from "generated/generated-models";
import { Validate } from "./IndueCardResetPinValidate";
import Title from "app/components/Title";
import { Loading } from "app/lib/components/Loading";
import { CError } from "app/common/CError";
import { useLocation, Navigate } from "react-router-dom";
import { DelayedRender } from "app/lib/components/DelayedRender";
import { useSecurityTokenMutation } from "core/apollo/SecurityTokenApollo";
import { getMaskedCardNumber } from "./utilities/cardNumber";
import { Alert, LoadingButton } from "@mui/lab";
import { Button } from "@mui/material";
const IndueCardResetPinPage = ({ handleClose, goBack = () => {
    return;
}, cardId, }) => {
    const [changePin, { data: changePinData, error: changePinError, tokenRequired },] = useSecurityTokenMutation(useIndueCardChangePinMutation());
    const { data, loading, error } = useIndueCardDetailsQuery({
        variables: { input: { CardId: cardId } },
        fetchPolicy: "network-only",
    });
    const handleSubmit = async (values) => {
        const pinString = values?.NewPin?.toString() ?? "";
        await changePin({
            variables: {
                input: {
                    CardId: cardId,
                    Pin: pinString,
                    TwoFactorToken: values.TwoFactorToken,
                },
            },
        });
    };
    const { pathname } = useLocation();
    const SuccesfullyChangedPin = () => {
        if (changePinData?.changePin?.Result === true) {
            return (_jsxs(Alert, { severity: "success", children: ["PIN successfully changed!", _jsx(DelayedRender, { delay: 1500, children: _jsx(Navigate, { to: pathname }) })] }));
        }
        else {
            return null;
        }
    };
    const handleCancelClick = () => {
        goBack();
        handleClose();
    };
    const card = data?.indueCardDetails;
    const initialValues = {
        CardId: cardId,
        NewPin: undefined,
        ConfirmPin: undefined,
    };
    if (loading) {
        return _jsx(Loading, {});
    }
    if (error || card == null) {
        return (_jsx(CError, { error: `Could not retrieve card details. ${error?.message}` }));
    }
    return (_jsx(Formik, { initialValues: initialValues, onSubmit: (values) => handleSubmit(values), validationSchema: () => Validate(tokenRequired), children: ({ isSubmitting }) => (_jsxs(_Fragment, { children: [_jsx(Title, { title: "Change PIN" }), _jsxs("p", { children: ["Choose a new 4 digit PIN. You should use this PIN the next time you are using card ", getMaskedCardNumber(card), "."] }), _jsxs(Form, { children: [_jsx(Input, { name: nameof("NewPin"), type: "wholeNumberAuth", label: "New PIN" }), _jsx(Input, { name: nameof("ConfirmPin"), type: "wholeNumberAuth", label: "Confirm PIN" }), _jsx(RequestMultiFactorTokenFormik, { name: "TwoFactorToken", showRequestNewToken: true, requestMfaOnDisplay: true, visible: tokenRequired }), changePinError && (_jsxs(Alert, { severity: "error", children: ["Could not change PIN. ", changePinError?.message] })), _jsx(SuccesfullyChangedPin, {}), _jsxs("div", { className: "button-row", children: [_jsx(Button, { className: "btn-cancel", id: "cancel", sx: { p: 1.5, mt: 1 }, variant: "contained", onClick: handleCancelClick, disabled: isSubmitting, children: "Cancel" }), _jsx(LoadingButton, { type: "submit", id: "submit", sx: { p: 1.5, mt: 1 }, loading: isSubmitting, loadingPosition: "end", variant: "contained", children: "Change PIN" })] })] })] })) }));
};
export { IndueCardResetPinPage };
